import "regenerator-runtime/runtime";

import "../polyfills/prepend"

import { initCCPA } from "./index";

window.FAMCCPA = { init: initCCPA }